import { render } from "./WoTThingDescriptionsEditView.vue?vue&type=template&id=bb0fa060"
import script from "./WoTThingDescriptionsEditView.vue?vue&type=script&lang=js"
export * from "./WoTThingDescriptionsEditView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__